import useLenis from "../hooks/useLenis";
import useSEO, { localBusinessLd } from "../hooks/useSEO";
import useEngagementTracking from "../hooks/useEngagement";
import { neutralizeWA } from "../config";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import Marquee from "../components/site/Marquee";
import Services from "../components/site/Services";
import InterventoRapido from "../components/site/InterventoRapido";
import Perche from "../components/site/Perche";
import Gallery from "../components/site/Gallery";
import Reviews from "../components/site/Reviews";
import QuoteWizard from "../components/site/QuoteWizard";
import FinalCTA from "../components/site/FinalCTA";
import Footer from "../components/site/Footer";
import FloatingWhatsApp from "../components/site/FloatingWhatsApp";

export default function Landing() {
  useLenis();
  useEngagementTracking();
  useSEO({
    title: "Muratore Imbianchino Roma | Lavori edili, tinteggiature e rifacimento bagni",
    description:
      neutralizeWA("Muratore e imbianchino a Roma: piccoli lavori edili, tinteggiature, rifacimento bagni, piastrellatura, cartongesso e riparazioni rapide. Preventivo gratuito su WhatsApp."),
    keywords:
      "muratore Roma, imbianchino Roma, pittore Roma, rifacimento bagno Roma, piccoli lavori edili Roma, cartongesso Roma, piastrellista Roma, riparazione muri Roma, intonaci Roma, tinteggiatura appartamenti Roma",
    path: "/",
    jsonLd: [localBusinessLd],
  });

  return (
    <div className="bg-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <InterventoRapido />
        <Perche />
        <Gallery />
        <Reviews />
        <QuoteWizard />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
